<script setup lang="ts">
    import { computed, toRef } from 'vue'

    import type { PanelCloserViewModel } from './PanelCloser'

    // ---------------- props / emits ----------------

    const props = defineProps<{
        viewModel: PanelCloserViewModel
    }>()

    const emit = defineEmits<{
        (e: 'close-access', surveyId: number): void
    }>()

    // ---------------- shortcuts ----------------

    const vm = toRef(props, 'viewModel')

    // ---------------- computed ----------------

    const opened = computed(() => vm.value?.opened)
    const surveyId = computed(() => vm.value.surveyId)

    // ---------------- actions ----------------

    function handleCloseAccess()
    {
        emit('close-access', surveyId.value)
    }

    function close()
    {
        vm.value.close()
    }
</script>

<template>
    <div class="modal-mask" v-if="opened">
        <div class="modal-wrapper">
            <div class="modal-dialog modal-lg modal-dialog-scrollable">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Closing a survey</h5>
                        <button type="button" class="close" @click="close">&times;</button>
                    </div>
                    <div class="modal-body">
                        <p class="lead">
                            You're about to close the survey.
                        </p><br />
                    </div>

                    <div class="modal-footer">
                        <button @click="handleCloseAccess" type="button" class="btn btn-primary">Close the survey</button>
                        <button @click="close" type="button" class="btn btn-outline-secondary">Cancel</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>